import { BellOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const EmptyList = styled.div`
  height: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #d9d9d9;
`;

export const EmptyBell = styled(BellOutlined)`
  font-size: 100px;
  margin-bottom: 10px;
`;
